import { Loading } from '@appkit4/react-components/loading';
import React from 'react'; // Import React

// Define props for LoadingSample, including style
interface LoadingSampleProps {
  style?: React.CSSProperties; // Optional style prop
}

// Modify LoadingSample to accept and apply the style prop
const LoadingSample: React.FC<LoadingSampleProps> = ({ style }) => {
    return (
      <Loading loadingType='linear' indeterminate={true} compact={false} style={style}></Loading>
    );
}

export default LoadingSample;
